/* eslint-disable react/no-array-index-key */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import Card from 'src/components/sharedComponents/Card/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import { transparentize, CHART_COLORS } from 'src/utils/chartsUtils';

const useStyles = makeStyles({
  root: {
    maxWidth: 250,
    minWidth: 240,
    minHeight: 250,
    marginRight: '10px',
    boxShadow: '0 4px 6px black',
    borderRadius: '5px',
    transition: '0.5s',
  },
  media: {
    height: 75,
  },
  table: {
    borderColor: transparentize(CHART_COLORS.orange, 0.4),
  },
});

const CardMapAttributes = ({ attributes = [] }) => {
  const classes = useStyles();
  const suma = attributes.reduce((a, b) => a + +b.peso, 0);
  return (
    <Card
      style={{
        backgroundColor: transparentize('#FFA500', 0.5),
      }}
      className={classes.root}
      plain
    >
      <CardHeader
        style={{
          background: transparentize('#FFA500', 0),
        }}
        color="customAuteco"
      >
        <ul>Beneficios</ul>
      </CardHeader>
      <CardActionArea>
        <CardContent>
          <Typography
            className={classes.media}
            gutterBottom
            variant="h5"
            component="h2"
          >
            Conjoint
          </Typography>
          <CardContent variant="body2" color="textSecondary" >
            <TableContainer component={Paper}>
              <Table
                className={classes.table}
                size="small"
                aria-label="a dense table"
              >
                <TableBody>
                  {attributes.map(({ atributo, peso, id }, index) => (
                    <TableRow key={id + index}>
                      <Tooltip title={atributo} arrow>
                        <TableCell component="th" size="small" scope="row">
                          {atributo.slice(0, 9)}
                          ...
                        </TableCell>
                      </Tooltip>
                      <TableCell align="left">
                        {peso || '-'}
                        %
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <br />
            <TableContainer component={Paper}>
              <Table
                className={classes.table}
                size="small"
                aria-label="table"
              >
                <TableBody>
                  <TableRow>
                    <TableCell component="th" size="small" scope="row">
                      T. attributos
                    </TableCell>
                    <TableCell align="left">
                      {suma.toFixed(2) || '-'}
                      %
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default CardMapAttributes;
